<oes-dynamic-form
  [json]="json"
  [readOnly]="isPastSubmissionDeadline"
  [simple]="simple"
  (formValid)="setFormValid($event)"
  (save)="customFormUpdated($event)">
</oes-dynamic-form>
